import {resolveFieldValueFromObject } from "@utils/common.js";
import { Fetcher, fetchWithRetry } from "@utils/fetcher.js";
import apiUrl from "@utils/url.js";

export async function fetchExternalServices(campno) {
  const url = apiUrl(`external_service/${campno}`);

  return fetchWithRetry("getJson", [url])
    .then((externalServices = []) => {
      return externalServices;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function addExternalService(body) {
  const url = apiUrl(`external_service`);
  return Fetcher.post(url, body)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function updateExternalServices(body, campno) {
  const url = apiUrl(`external_service/${campno}`);
  return Fetcher.put(url, body)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function removeExternalService(campno, entno) {
  const url = apiUrl(`external_service/${campno}/${entno}`);

  return Fetcher.delete(url)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

// Subscriptions external services
export async function fetchSubsExternalServices(subsNo, extNo , entitlementNo = -1) {
  const url = apiUrl(`subs-external-service?subsno=${subsNo}&extno=${extNo}&entitlementno=${entitlementNo}`);

  return fetchWithRetry("getJson", [url])
    .then((externalServices = []) => {
      return externalServices;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function removeSubsExternalService(subsNo, extNo, entitlementNo) {
  const url = apiUrl(`subs-external-service?subsno=${subsNo}&extno=${extNo}&entitlementno=${entitlementNo}`);
  return Fetcher.delete(url)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function addSubsExternalService(body) {
  const url = apiUrl(`subs-external-service`);
  return Fetcher.post(url, body)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

export async function updateSubsExternalServices(body) {
  const url = apiUrl(`subs-external-service`);
  return Fetcher.put(url, body)
    .then((response) => {
      console.log({response})
      return response;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
}

